import React, { useEffect, useState } from "react";
import { Document, Page } from "react-pdf";
import { DownloadOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, message, Upload,Form,Modal,Tooltip,Input,Select,DatePicker } from "antd";
import { API_URL } from "../../helper/axioscontants";
import useJDStore from "../../store/jd.store";
import useResumeStore from "../../store/resume.store";
import dayjs from "dayjs";
import "./CandidateProfilePreview.scss";

import { pdfjs } from "react-pdf";
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";
import useCandidateStore from "../../store/candidateModal.store";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

function CandidateProfilePreview({ jdID }) {
  const types = ["application/pdf"];
  const [numPages, setNumPages] = useState(null);
    const [currentMsg, setResponse] = useState("No Error");
  const { selectedProfileResume, getProfileResumeDetails } = useResumeStore();
  const { isCandidateUpdateModalOpen, handleUpdateModalOk, handleUpdateModalCancel,setCandidateUpdateModalOpen } =
        useCandidateStore();
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const defaultInput = {
      resumesource: "",
      resumedate: "",
  };
  const [formInput, setFormInput] = useState(defaultInput);
  const [scale, setScale] = useState(1);
  const baseURL = API_URL;
  const [form] = Form.useForm(); 
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const props = {
    accept: "pdf",
    showUploadList: true,
    method: "PUT",
    action: `${baseURL}/updateresume/${userDetails.qhoid}/${userDetails.qhuid}/jds/${jdID}/resumes/${selectedProfileResume.qhrid}`,
    name: "pdf",
    headers: {
      authorization: "authorization-text",
    },
    data: {
      resumesource: formInput?.resumesource,
      resumedate: formInput?.resumedate
    },
    beforeUpload(file) {
        // Check for Resume Source first
        if (!formInput.resumesource) {
            message.warning("Please select a Resume Source before uploading.");
            return Upload.LIST_IGNORE; // Stops the upload process
        }
        if (!formInput.resumedate) {
            message.warning("Please select a Resume Date before uploading.");
            return Upload.LIST_IGNORE; // Stops the upload process
        }

        if (!types.includes(file.type)) {
            message.error(`${file.name} is not a pdf file`);
            return Upload.LIST_IGNORE;
        } 
    }, 
    onChange(info) {
      const { status } = info.file;

      if (status === "done") {
        message.success(`Resume Updated`);

        getProfileResumeDetails(jdID, selectedProfileResume.qhrid);
      } else if (status === "error") {
                var responseData = info.file.response
                if(responseData.status == "RESUME_NOT_CHANGED"){
                    message.error(`Resume is same`);
                }else if(responseData.status == "EMAIL_MISMATCH"){
                    message.error(`Email not matching`);
                }else{
                    message.error(`${info.file.name} upload failed.`);
                }                
                setResponse(responseData.responseData)
                form.resetFields();         
      }
    },
    itemRender(originNode, file) {
            return (
            <div style={{ marginBottom: 10 }}>
                {originNode}
                {file.status === "done" && file.response && (
                <div style={{ color: "green", marginTop: 4 }}>
                    ✅ {file.response.status}
                </div>
                )}
                {file.status === "error" && (
                <div style={{ color: "red", marginTop: 4 }}>❌ {file.response.error}</div>
                )}
            </div>
            );
    },    
  };
  const OnSelectChangeResume = (value) => {
        console.log("selected",value);
        
        setFormInput((inputs) => ({
            ...inputs,["resumesource"]: value,
        }));
    }

    const OnDateChange = (date, dateString) => {
        console.log("selected date", date, dateString);
        setFormInput((inputs) => ({
            ...inputs,["resumedate"]: dateString || null,
        }));
    }
    
  return (
    <div className="candidate-resume-preview-container">
      <div className="candidate-resume-preview-title">
        <div className="candidate-resume-preview-left">
          <h2>Resume</h2>
          <p>
            Updated On:{" "}
            {selectedProfileResume?.firstuploadedby?.teamdetails?.updatedon}
          </p>
        </div>
      </div>
      <div className="candidate-resume-preview-download">
        <a
          href={`data:application/pdf;base64,${selectedProfileResume?.resume}`}
          download={`[${selectedProfileResume?.qhrid}]-${
            selectedProfileResume?.personaldetail.name
          }-Resume-${new Date().toLocaleDateString()}.pdf`}
            style={{
              padding: "8px 12px",
              background: "#007bff",
              color: "#fff",
              borderRadius: 4,
              textDecoration: "none",
            }}
          >
            Download <DownloadOutlined />
          </a>

          <Modal
              title="Update Resume"
              open={isCandidateUpdateModalOpen}
              footer={null}
              onCancel={() => {
                handleUpdateModalCancel();
                setFormInput(defaultInput);
                form.resetFields();
            }}
          >
              <Form
                  labelCol={{ flex: "150px" }}
                  form={form}
                  name="candidateUpdateModalForm"
                  labelAlign="left"
                  labelWrap
                  wrapperCol={{ flex: 1 }}
                  colon={false}
              >
 
                  <Form.Item
                                  rules={[{ required: true, message: "Resume Source is required!" }]}
                                  name="resumesource"
                                  className="candidateAddModel-input"
                                  label="Resume source"
                              >
                                      <Select                       
                                          required={true}
                                          name="resumesource"
                                          className="candidateAddModel-input" 
                                          onChange={OnSelectChangeResume}                               
                                        value={formInput.resumesource}
                                          options={[
                                              { value: 'Naukri', label: 'Naukri' },
                                              { value: 'Foundit', label: 'Foundit' },
                                              { value: 'Company DB', label: 'Company DB' },
                                              { value: 'QuallyHire DB', label: 'QuallyHire DB' },
                                              { value: 'Employee Referral', label: 'Employee Referral'},
                                              { value: 'Bulk Mail Naukri', label: 'Bulk Mail Naukri' },
                                              { value: 'Candidate Referral', label: 'Candidate Referral' },
                                              { value: 'Linkedin Job Post', label: 'Linkedin Job Post' },
                                              { value: 'Naukri Job Post', label: 'Naukri Job Post' },
                                              { value: 'Other Job Posts', label: 'Other Job Posts'},
                                              { value: 'From Partners', label: 'From Partners'},
                                          ]}
                                      />                         
                  </Form.Item>                                                              
                  <Form.Item
                                  rules={[{ required: true, message: "Date is required!" }]}
                                  name="resumedate"
                                  className="candidateAddModel-input"
                                  label="Resume Date"
                              >
                                      <DatePicker
                                          name="resumedate"
                                          picker="month"   // 👈 IMPORTANT
                                          format="MM-YYYY"
                                          placeholder="Select Date"
                                          onChange={OnDateChange}
                                          value={formInput.resumedate? dayjs(formInput.resumedate, "MM-YYYY"): null }
                                      />
                  </Form.Item> 
                <div className="candidateAddModel-btns">
                  <Upload {...props}>
                    <Tooltip
                      title={
                        formInput.resumesource !="" || formInput.resumedate !="" ? null : "Please select a Resume Source and Date"
                      }
                      placement="bottom"
                      color="white"
                      styles={{
                        body: {
                          backgroundColor: "white",
                          color: "black",
                          borderRadius: "4px",
                          border: "1px solid #d9d9d9",
                        },
                      }}
                    >
                      <Button
                        icon={<UploadOutlined />}
                        disabled={!formInput.resumesource || !formInput.resumedate}
                      >
                        Click to Upload
                      </Button>
                    </Tooltip>
                  </Upload>
                </div>
              </Form>
          </Modal>

            <Button
              style={{ marginLeft: "10px", height: "35px" }}
              onClick={() =>   {setCandidateUpdateModalOpen(true)}}
              icon={<UploadOutlined />}
            >
              Update
            </Button>

      </div>
      <div className="candidate-resume-preview-wrapper-container">
        <div className="candidate-resume-preview-wrapper">
          <Document
            file={`data:application/pdf;base64,${selectedProfileResume?.resume}`}
            onLoadSuccess={onDocumentLoadSuccess}
          >
            {Array.from(new Array(numPages), (el, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                scale={scale}
              />
            ))}
          </Document>
        </div>
      </div>
    </div>
  );
}

export default CandidateProfilePreview;
